var Line = require('./Line');

var Lines = function () {
    var self = this;

    this.list = ko.observableArray();

    this.removeItem = function (item) {
        for (var i = 0; i < self.list().length; i++) {
            if (self.list()[i] === item) {
                self.list.splice(i, 1);
                break;
            }
        }
    };

    this.addItem = function (data) {
        var match_found = false;

        for (var i = 0; i < self.list().length; i++) {
            if (self.list()[i].isbn === data.isbn) {
                self.list()[i].quantity(self.list()[i].quantity() + 1);
                match_found = true;
                break;
            }
        }

        if (!match_found) {
            self.list.push(new Line(data));
        }

        self.list.valueHasMutated();
    };

    this.clean = function () {
        self.list([]);
    };

    this.isEmpty = function () {
        return self.list().length == 0;
    };

    this.isValid = function () {
        if (self.isEmpty()) return false;

        var isValidLines = true;
        self.list().forEach(function (item) {
            isValidLines = isValidLines && item.isValid();
        });

        return isValidLines;
    };

    this.getData = function () {
        return self.list().map(function (item) {
            return item.getData();
        });
    };

    this.addItems = function (items) {
        if (!Array.isArray(items) || items.length == 0) return;

        items.forEach(function (item, index) {
            if (index == 0) item.focused = true;
            self.addItem(item);
        });
    };

    this.findItem  = function (isbn) {
        var list = self.list();
        var list_length = list.length;

        for (var counter = 0; counter < list_length; counter++) {
            if (list[counter].isbn === isbn) return counter;
        }
        
        return -1;
    };

    this.getItemsISBNS = function () {
        return self.list().reduce(function (previous, item) {
            previous[item.isbn] = true;
            return previous;
        }, {});
    }
};

module.exports = Lines;


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/CreateNewOrder/Lines.js
// module id = 20
// module chunks = 0